import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat } from '../../function/Format';

const ModalSuratBelumMenikah = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: '',
		id_jenis: "",
		nik: "",
		nik_pelapor: "",
		nama_pemohon: "",
		tempat_lahir: "",
		tanggal_lahir: "",
		jenis_kelamin: "",
		status_perkawinan: "",
		pekerjaan: "",
		agama: "",
		alamat: "",
		tujuan_pembuatan: "Surat Pernyataan Belum Menikah",
		nama_saksi1: "",
		hubungan_saksi1: "",
		nama_saksi2: "",
		hubungan_saksi2: "",
		status_ttd: ''
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		tmplistPenduduk: optionData.tmplistPenduduk,
		nikStat: null,
		frmShdk: optionData.frmShdk,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			formSaksi: "none",
			frmPreviewDraft: false,
			jenis_form: ""
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		console.log(data);

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			frmNik: optionData.frmNik,
			frmShdk: optionData.frmShdk,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const getPenduduk = (e, sel, jns) => {
		if (e) {
			if (kioskMode) {
				props.setLoadingPreview(true)
			}
			else{
				setAlert({
					loadingPreview: true
				})
			}

			Get("penduduk/find", e.value, data => {
				if(data.results){
					const alamat = generateAlamat(data.results);
					let alamat_kk = "";
			
					if(data.results.data_kk){
					  alamat_kk = data.results.data_kk.alamat
					}
			
					// pelapor
					setFormData({
						...formData,
						nikStat: e,
						status: {
							...formData.status,
							dataPenduduk: "block",
						},
					})

					setDt({
						...dt,
						nik: data.results.id,
						nik_pelapor: data.results.id,
						kk: data.results.id_kk,
						nama: data.results.nama,
						nama_pemohon: data.results.nama,
						tempat_lahir: data.results.tempat_lahir,
						tanggal_lahir: new Date(
							data.results.tanggal_lahir
						),
						pekerjaan: data.results.data_pekerjaan.nama,
						pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
						agama: data.results.data_agama.nama,
						status_perkawinan: data.results.status_perkawinan,
						jenis_kelamin: data.results.jk,
						alamat: alamat,
						alamat_kk: alamat_kk,
						kewarganegaraan: 'Indonesia',
					})

					if (kioskMode) {
						props.setLoadingPreview(false);
					}
					setAlert({
						loadingPreview: false
					});
				}
				else{
					if (kioskMode) {
						props.setLoadingPreview(false);
					}

					setAlert({
						loadingPreview: false
					});
				}
			})
		} else {
			setDt({
				...dt,
				nama_pemohon: '',
				tempat_lahir: '',
				tanggal_lahir: null,
				pekerjaan: '',
				pendidikan_terakhir: '',
				agama: '',
				status_perkawinan: '',
				jenis_kelamin: '',
				alamat: '',
				alamat_kk: '',
			})
			setFormData({
				...formData,
				status: {
					...formData.status,
					dataPenduduk: "none"
				},
				nikStat: null
			})
			setAlert({
				loadingPreview: false
			})
		}
	};

	const simpan = (e) => {
		e.preventDefault();
		
		if (kioskMode){
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}

		let validasiPelapor = formData.nikStat;

		let validasiHubunganSaksi1 = dt.hubungan_saksi1

		let validasiHubunganSaksi2 = dt.hubungan_saksi2
		if (formData.status.formSaksi === "none") {
			validasiHubunganSaksi2 = true
		}

		if (validasiPelapor && validasiHubunganSaksi1 && validasiHubunganSaksi2) {
			if (kioskMode) {
				props.setLoadingPreview(true)
			}

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'),
				tujuan_pembuatan: "Surat Pernyataan Belum Menikah",
				hubungan_saksi1: dt.hubungan_saksi1.label,
			}

			if (formData.status.formSaksi === "none") {
				bodyRaw.hubungan_saksi2 = ''
			} else {
				bodyRaw.nama_saksi2 = dt.nama_saksi2.trim();
				bodyRaw.hubungan_saksi2 = dt.hubungan_saksi2.label
			}

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}
			console.log(bodyRaw);

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			Post(
				"surat-keterangan/grup/" + metode + "/belum-menikah",
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					// Kalau mode kiosk
					if (kioskMode) {
						if (res.status === resstat) {
							let dataAntrian = {
								nama: props.data.results.nama,
								nik: props.data.results.id,
								keterangan: '',
								uuid_surat:res.data.results.uuid_surat,
								kode_surat:res.data.results.kode_surat,
							};
					
							// Set Data Surat
							props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {

									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Pernyataan Belum Menikah', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Pernyataan Belum Menikah', 'gagal');
									}
								});
							}.bind(this),1000)
						}
						else{
							props.setLoadingPreview(false)
							props.getAntrian('Surat Pernyataan Belum Menikah', 'gagal');
						}

					} else { // Kalau bukan kiosk
						if (res.status === resstat) {
							const alertData = {
								get_data_surat: {
								uuid_surat: res.data.results.uuid_surat,
								kode_surat: res.data.results.kode_surat
								},
								status: {
								frmPreviewDraft: true,
								jenis_form: psn
								}
								// show: true,
								// basicType: "success",
								// basicTitle: "Data Surat Pernyataan Belum Menikah",
								// pesanAlert: "Berhasil " + psn + " Data",
								// successAlert: true,
							}
							setAlert({
								loadingPreview: false
							})
							setAlert(alertData)
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Pernyataan Belum Menikah",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}
				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Surat Pernyataan Belum Menikah', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan} >
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Pernyataan Belum Menikah</h5>
					</div>
					<div className="modal-body">
						<p>
							Data identitas akan terisi secara otomatis saat NIK dipilih.
							Jika ada ketidak sesuaian data, silakan ubah di data master
							penduduk.
						</p>
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik", "pelapor");
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										name="nik"
										options={formData.frmNik}
										placeholder="Pilih NIK"
										onInputChange={e => handleInputChangeNIK(e, 'nik')}
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.dataPenduduk }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pemohon
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pemohon"
										type="text"
										placeholder="Nama Pemohon"
										value={dt.nama_pemohon}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tempat_lahir"
										type="text"
										placeholder="Tempat Lahir"
										value={dt.tempat_lahir}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										type="text"
										placeholder="Tanggal Lahir"
										value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Alamat
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="alamat_kk"
									type="text"
									placeholder="Alamat"
									value={dt.alamat_kk}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Wilayah
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="alamat"
									type="text"
									placeholder=""
									value={dt.alamat}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								&nbsp;
							</Label>
							<Col sm="9">
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
							</Col>
						</FormGroup>
						</div>

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Nama Saksi 1
							</Label>
							<Col sm="9">
								<input
									data-testid="nama saksi1"
									name="nama_saksi1"
									className="form-control"
									id="nama_saksi1"
									type="text"
									placeholder="Nama Saksi"
									defaultValue={dt.nama_saksi1}
									value={dt.nama_saksi1}
									onChange={e => changeInputText(e, "nama_saksi1")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Hubungan Saksi 1
							</Label>
							<Col sm="9">
								<Select
									inputId="hubungan_saksi1"
									classNamePrefix="select"
									onChange={e => {
										setDt({
											...dt,
											hubungan_saksi1: e
										})
									}}
									defaultValue={dt.hubungan_saksi1}
									value={dt.hubungan_saksi1}
									name="hubungan_saksi1"
									options={formData.frmShdk}
									placeholder="Pilih Hubungan Saksi"
								/>
								{/* <input
									data-testid="hubungan saksi1"
									name="hubungan_saksi1"
									className="form-control"
									id="hubungan_saksi1"
									type="text"
									placeholder="Hubungan Saksi"
									defaultValue={dt.hubungan_saksi1}
									value={dt.hubungan_saksi1}
									onChange={e => changeInputText(e, "hubungan_saksi1")}
									required
								/> */}
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.formSaksi }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Saksi 2
								</Label>
								<Col sm="9">
									<input
										data-testid="nama saksi2"
										name="nama_saksi2"
										className="form-control"
										id="nama_saksi2"
										type="text"
										required={formData.status.formSaksi === "none" ? false : true}
										placeholder="Nama Saksi"
										defaultValue={dt.nama_saksi2}
										value={dt.nama_saksi2}
										onChange={e => changeInputText(e, "nama_saksi2")}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Hubungan Saksi 2
								</Label>
								<Col sm="9">
									<Select
										inputId="hubungan_saksi2"
										classNamePrefix="select"
										onChange={e => {
											setDt({
												...dt,
												hubungan_saksi2: e
											})
										}}
										defaultValue={dt.hubungan_saksi2}
										value={dt.hubungan_saksi2}
										name="hubungan_saksi2"
										options={formData.frmShdk}
										placeholder="Pilih Hubungan Saksi 2"
									/>
									{/* <input
										data-testid="hubungan saksi2"
										name="hubungan_saksi2"
										className="form-control"
										id="hubungan_saksi2"
										required={formData.status.formSaksi === "none" ? false : true}
										type="text"
										placeholder="Hubungan Saksi"
										defaultValue={dt.hubungan_saksi2}
										value={dt.hubungan_saksi2}
										onChange={e => changeInputText(e, "hubungan_saksi2")}
									/> */}
								</Col>
							</FormGroup>
						</div>
						<button
							type="button"
							className={
								formData.status.formSaksi === "none"
									? "btn btn-primary-custom"
									: "btn btn-danger"
							}
							onClick={() => {
								if (formData.status.formSaksi === "none") {
									setFormData({
										...formData,
										status: {
											...formData.status,
											formSaksi: ""
										}
									})
								} else {
									setDt({
										...dt,
										nama_saksi2: '',
										hubungan_saksi2: '',
									})
									setFormData({
										...formData,
										status: {
											...formData.status,
											formSaksi: "none"
										}
									})
									//console.log("disnii");
									// document.getElementById("nama_saksi2").value = "";
									// document.getElementById("hubungan_saksi2").value = "";
									// formData.status.formSaksi = "none";
									// this.forceUpdate();
								}
							}}
						>
							{formData.status.formSaksi === "none"
								? "Tambah Saksi 2 "
								: "Hapus Saksi 2"}
						</button>

					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false,
										frmPreviewDraft: false,
										jenis_form: "",
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
							// disabled={formData.status && formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratBelumMenikah;
